const Items = () => {
  return (
    <>
      <h2>Items</h2>
      <div style={{display: "flex", justifyContent: "center"}}>
        <h6>Under construction.</h6>
      </div>
    </>
  );
};

export default Items;